import * as electron from '@utils/electron';
import type { createBrowserRouter } from 'react-router-dom';
import { win } from './win';

type DataRouter = ReturnType<typeof createBrowserRouter>;

type NavigateTo =
  | string
  | { pathname?: string; search?: string; hash?: string };

let appRouter: DataRouter | undefined;

/**
 * Wire the application's data router so the imperative navigation helpers below
 * can drive it. React Router v6 data routers own their own history, so we route
 * imperative `push`/`replace` calls through the router instead of through a
 * standalone `history` instance (which the v6 router would not observe).
 */
export const setAppRouter = (router: DataRouter): void => {
  appRouter = router;
};

interface NavigationHelper {
  push: (to: NavigateTo) => void;
  replace: (to: NavigateTo) => void;
  pushMain: (path: string) => void;
}

export const history: NavigationHelper = {
  push: (to: NavigateTo): void => {
    void appRouter?.navigate(to);
  },
  replace: (to: NavigateTo): void => {
    void appRouter?.navigate(to, { replace: true });
  },
  pushMain: (path: string): void => {
    electron.send('navigateMain', { path });
  },
};

if (win.Cypress) {
  (win as anyOk).routerHistory = history;
}
